import { TrunkPostRequestSchema } from "callable-data-objects";
import {
  CallableInput,
  CallFormatSelect,
  CountrySelect,
  RegionSelect,
} from "Components/Shared";
import SimpleBreadcrumbs from "Components/Shared/SimpleBreadcrumbs";
import { Field, Formik } from "formik";
import { useTrunk } from "Hooks/Endpoints";
import { isEmpty } from "lodash";
import React from "react";
import {
  Button,
  Container,
  Divider,
  Form,
  Header,
  Segment,
} from "semantic-ui-react";

const TrunkCreateForm = () => {
  const { createTrunk, save, uncreate } = useTrunk();

  return (
    <Container fluid>
      <SimpleBreadcrumbs title='Trunks' subtitle='Create' onBack={uncreate} />

      <Segment>
        <Header as='h3'>Create Trunk</Header>
        <Divider />
        <Formik
          initialValues={createTrunk}
          validationSchema={TrunkPostRequestSchema}
          onSubmit={(values, actions) => {
            save(values);
          }}
        >
          {(props) => (
            <Form onSubmit={props.handleSubmit}>
              <Field
                name='description'
                label='Description'
                component={CallableInput}
              />
              <Form.Group widths='equal'>
                <Field
                  name='ip'
                  label='IPv4 Address'
                  placeholder='1.1.1.1'
                  component={CallableInput}
                />
                <Field
                  name='port'
                  label='Port'
                  type='number'
                  min='5000'
                  max='7000'
                  placeholder='5060'
                  component={CallableInput}
                />
              </Form.Group>
              <Form.Group widths='equal'>
                <CountrySelect
                  name='countryCode'
                  label='Presentation Country'
                />
                <RegionSelect name='zone' label='Voice Region' />
              </Form.Group>
              <Form.Group widths='equal'>
                <CallFormatSelect name='callerFormat' label='ANI Format' />
                <CallFormatSelect name='calledFormat' label='DNIS Format' />
              </Form.Group>
              <Button primary type='submit' disabled={!isEmpty(props.errors)}>
                Submit
              </Button>
            </Form>
          )}
        </Formik>
      </Segment>
    </Container>
  );
};

export default TrunkCreateForm;
